import Form from './_.extend';
import stores from "../models/index";
import PostMessageModel from "../models/PostMessageModel";

export const optionsPostMessageStatus = [
    { value: 'scheduled', label: 'Scheduled', type: 'maintenance' },
    { value: 'inprogress', label: 'In Progress', type: 'maintenance' },
    { value: 'completed', label: 'Completed', type: 'maintenance' },
    { value: 'investigating', label: 'Investigating', type: 'incident' },
    { value: 'identified', label: 'Identified', type: 'incident' },
    { value: 'update', label: 'Update', type: 'incident' },
    { value: 'resolved', label: 'Resolved', type: 'incident' }
];

export default class PostMessageForm extends Form {

    postId;

    constructor() {
        super({
            fields: {
                postid: {
                    label: "Post Id",
                    rules: 'required',
                    handlers: {
                        onChange: field => (e) => {
                            //field.set(e.target.value); 
                            //var post = stores.postStore.getPost(e.target.value);
                            //if (post && typeof (post) !== 'undefined') {
                            //    alert("Add message for post " + post.title);
                            //} else {
                            //    alert("post not found");
                            //}
                        }
                    },
                    observers: [{
                        key: 'value',
                        call: ({ form, field, change }) => {
                            var post = stores.postStore.getPost(field.value);
                            if (typeof (post) !== 'undefined' && post.length > 0) {
                                let filteredOptions = optionsPostMessageStatus.filter(status => status.type === post[0].type);
                                form.$('status').set('extra', filteredOptions);
                                
                            }                            
                        },
                    }]
                },                
                text: {
                    label: 'Text',
                    placeholder: 'Type your update here',
                    rules: 'required|string'
                },
                status: {
                    label: 'Status',
                    rules: 'required',
                    //extra: optionsPostMessageStatus
                }
            }
        }, { name: 'PostMessage' });
    }

    hooks() {
        return {
            onSuccess(form) {
                // get field values
                console.log('Post Message Values!', form.values());

                var formData = form.values();
                var newpostmessage = new PostMessageModel(formData.postid, formData.status.value, formData.text);
                stores.postStore.addPostMessage(newpostmessage);
                form.hide();
                form.reset(true);
            },
            onError(form) {
                let errorMessage = '', errors = form.errors();
                for (let field in errors) {
                    if (errors[field] !== null)
                        errorMessage += errors[field] + '\n';
                }
                alert(errorMessage);
            },
            onSubmit(instance) {
                console.log('-> onSubmit HOOK -', instance.path || 'form');
            },
            onClear(instance) {
                // eslint-disable-next-line
                console.log('-> onClear HOOK -', instance.path || 'form');
            },

            onReset(instance) {
                // eslint-disable-next-line
                console.log('-> onReset HOOK -', instance.path || 'form');
            },

        };
    }
    
}


// WEBPACK FOOTER //
// ./src/forms/PostMessageForm.js